import { Badge } from "@/components/ui/badge";

const EnterpriseTrust = () => {
  const industries = [
    "SaaS & Technology",
    "Professional Services",
    "Financial Services",
    "Manufacturing",
  ];

  const integrations = [
    { name: "Salesforce", logo: "SF" },
    { name: "HubSpot", logo: "HS" },
    { name: "LinkedIn", logo: "in" },
    { name: "Marketo", logo: "MK" },
    { name: "Pipedrive", logo: "PD" },
    { name: "Zapier", logo: "ZP" },
  ];

  const stats = [
    { value: "200+", label: "B2B Clients" },
    { value: "£50M+", label: "Pipeline Generated" },
    { value: "4.9/5", label: "Client Rating" },
    { value: "92%", label: "Client Retention" },
  ];

  return (
    <section className="py-12 md:py-16 bg-background border-y border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Stats Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <p className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-secondary to-accent bg-clip-text text-transparent">
                  {stat.value}
                </p>
                <p className="text-sm text-muted-foreground">{stat.label}</p>
              </div>
            ))}
          </div>

          {/* Industries */}
          <div className="text-center mb-10">
            <p className="text-sm text-muted-foreground mb-4">Trusted by B2B companies in:</p>
            <div className="flex flex-wrap justify-center gap-3">
              {industries.map((industry, index) => (
                <Badge 
                  key={index} 
                  variant="outline" 
                  className="px-4 py-1.5 text-sm bg-secondary/5 border-secondary/20"
                >
                  {industry}
                </Badge>
              ))}
            </div>
          </div>

          {/* Integrations */}
          <div className="text-center">
            <p className="text-sm text-muted-foreground mb-4">Integrates with your tech stack:</p>
            <div className="flex flex-wrap justify-center gap-4">
              {integrations.map((integration, index) => (
                <div
                  key={index}
                  className="w-14 h-14 md:w-16 md:h-16 bg-muted rounded-lg flex items-center justify-center border border-border hover:border-secondary/50 transition-colors"
                  title={integration.name}
                >
                  <span className="text-sm font-bold text-muted-foreground">{integration.logo}</span>
                </div>
              ))}
            </div>
            <p className="text-xs text-muted-foreground mt-4">
              + custom integrations available
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseTrust;
